import { ImmutableMap } from '@/lib/immutable/ImmutableMap'
import { IAction } from '@/redux/actions/action-helpers'
import { FareRuleTypes } from '@/redux/actions/actions.types'
import { ApplicationState } from '@/redux/stores/types'
import { FareRulesRequestJobParams, FareRulesResponse } from '@/travelsuit/fare-rules'

type FareRulesState = ApplicationState['fareRules']

const emptyFareRulesState: FareRulesState = new ImmutableMap()

function fareRulesReducer(
	state: FareRulesState = emptyFareRulesState,
	action: IAction<FareRulesResponse, FareRulesRequestJobParams>,
): FareRulesState {
	switch (action.type) {
		case FareRuleTypes.GetFareRules.UPDATE:
		case FareRuleTypes.GetFareRules.SUCCESS:
			if (action.requestPayload && action.payload?.fare_components) {
				return state.set(action.requestPayload.fare_group_key, action.payload.fare_components)
			}
	}
	return state
}

export default fareRulesReducer
